import React, { useEffect, useState, useRef } from "react";
import { motion, useAnimation } from "framer-motion";

import "./JabanomicsSection.css";
import StyledMdText from "../../../common/components/styledMdText/StyledMdText";
import StyledH4Heading from "../../../common/components/styledH4Heading/StyledH4Heading";
import StyledH6Heading from "../../../common/components/styledH6Heading/StyledH6Heading";
import StyledCustomHeading from "../../../common/components/styledCustomHeading/styledCustomHeading";

const styles = {
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundImage: "url('/assets/Jabanomics-bg.png')",
  overflowX: "hidden",
};

const JabanomicsSection = () => {
  const [isMobile, setIsMobile] = useState(false);
  const controlsLeft = useAnimation();
  const controlsRight = useAnimation();
  const sectionRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            controlsLeft.start({
              opacity: 1,
              x: 0,
              transition: { duration: 0.7, ease: "easeInOut" },
            });
            controlsRight.start({
              opacity: 1,
              x: 0,
              transition: { duration: 0.7, ease: "easeInOut" },
            });
          } else {
            controlsLeft.start({ opacity: 0, x: isMobile ? -50 : -150 });
            controlsRight.start({ opacity: 0, x: isMobile ? -50 : 150 });
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, [controlsLeft, controlsRight, isMobile]);

  return (
    <motion.div
      id="tokenomics"
      ref={sectionRef}
      style={styles}
      className="flex justify-center w-full 2xl:h-[128vh] relative overflow-hidden"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1, ease: "easeInOut" }}
    >
      <div className="flex flex-col justify-center items-center gap-60 w-11/12 sm:w-[85%] lg:w-[95%] xl:w-[85%] md:pb-5 lg:pb-10 lg:pt-0 mt-[-50px] sm:mt-[-5%] lg:mt-0">
        {/* Positioned Image */}
        <div className="absolute top-[4%] sm:top-0 left-0 w-[20%] lg:w-[25%] satellite">
          <img
            src="/assets/Jabanomics-satellite.png"
            alt="Jabanomics Satellite"
          />
        </div>

        {/* Torch Light Heading */}
        <div className="w-full">
          <div className="absolute m-auto left-0 right-0 top-5 md:top-10">
            <div className="flex justify-center w-full relative">
              <img
                src="/assets/torch-flash.png"
                alt="Torch Flash"
                className="w-full md:w-4/5 lg:w-[70%] xl:w-fit"
              />
              <StyledCustomHeading font="text-black text-center strokeText2 absolute m-auto left-10 sm:left-20 right-0 top-[21%] md:top-6 lg:top-7 xl:top-6 bottom-0 w-fit">
                Jabanomics!! Baby
              </StyledCustomHeading>
            </div>
          </div>
        </div>

        {/* Jabanomics Childs */}
        <div className="flex flex-col justify-center items-center gap-5 w-full relative pb-40 md:pb-0">
          <div className="flex flex-col lg:flex-row justify-between lg:items-start gap-8 w-full lg:absolute top-0 2xl:top-0 3xl:top-20">
            {/* Left Side Childs */}
            <motion.div
              className="flex flex-col items-start lg:items-end justify-start gap-8 lg:gap-20 lg:w-[30%]"
              initial={{ opacity: 0, x: isMobile ? 0 : -100 }}
              animate={controlsLeft}
            >
              {/* detail 1 */}
              <motion.div
                className="flex flex-row-reverse lg:flex-row items-start gap-5"
                initial={{ opacity: 0, x: isMobile ? 0 : -100 }}
                animate={controlsLeft}
              >
                <div className="text-start lg:text-end">
                  <StyledH6Heading font="text-black 2xl:text-h4">
                    Token supply
                  </StyledH6Heading>
                  <StyledH4Heading font="text-green">420.69T</StyledH4Heading>
                </div>
                <div className="min-w-fit">
                  <img
                    src="/assets/Jabanomics-baby.png"
                    alt="Jabanomics Baby"
                    className="w-full"
                  />
                </div>
              </motion.div>
              {/* detail 2 */}
              <motion.div
                className="flex flex-row-reverse lg:flex-row items-start gap-5"
                initial={{ opacity: 0, x: isMobile ? 0 : -100 }}
                animate={controlsLeft}
              >
                <div className="text-start lg:text-end flex flex-col items-start lg:items-end w-fit">
                  <StyledH6Heading font="text-black 2xl:text-h4">taxes</StyledH6Heading>
                  <StyledMdText font="text-green">
                    zero percent taxes, no bullshit. It’s that simple.
                  </StyledMdText>
                  <StyledH4Heading font="text-green">
                    0<span className="!font-druk-wide-bold text-[18px]">%</span>{" "}
                    Buy 0
                    <span className="!font-druk-wide-bold text-[18px]">%</span>{" "}
                    Sell
                  </StyledH4Heading>
                </div>
                <div className="min-w-fit">
                  <img
                    src="/assets/Jabanomics-baby.png"
                    alt="Jabanomics Baby"
                    className="w-full"
                  />
                </div>
              </motion.div>
            </motion.div>

            {/* Right Side Childs */}
            <motion.div
              className="flex flex-col items-start justify-start gap-8 lg:gap-20 lg:w-[30%]"
              initial={{ opacity: 0, x: isMobile ? 0 : 100 }}
              animate={controlsRight}
            >
              {/* detail 3 */}
              <motion.div
                className="flex items-start gap-5"
                initial={{ opacity: 0, x: isMobile ? 0 : 100 }}
                animate={controlsRight}
              >
                <div className="min-w-fit">
                  <img
                    src="/assets/Jabanomics-baby.png"
                    alt="Jabanomics Baby"
                    className="w-full"
                  />
                </div>
                <div className="text-start">
                  <StyledH6Heading font="text-black 2xl:text-h4">Liquidity</StyledH6Heading>
                  <StyledH4Heading font="text-green">
                    100
                    <span className="!font-druk-wide-bold text-[18px]">
                      %
                    </span>{" "}
                    Locked
                  </StyledH4Heading>
                </div>
              </motion.div>
              {/* detail 4 */}
              <motion.div
                className="flex items-start gap-5"
                initial={{ opacity: 0, x: isMobile ? 0 : 100 }}
                animate={controlsRight}
              >
                <div className="min-w-fit">
                  <img
                    src="/assets/Jabanomics-baby.png"
                    alt="Jabanomics Baby"
                    className="w-full"
                  />
                </div>
                <div className="text-start">
                  <StyledH6Heading font="text-black 2xl:text-h4">Contract</StyledH6Heading>
                  <StyledH4Heading font="text-green">renounced</StyledH4Heading>
                </div>
              </motion.div>
            </motion.div>
          </div>

          {/* Jaba The Pepe */}
          <motion.div
            className="swayingImage 2xl:w-1/2 3xl:w-1/2"
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, delay: 0.5, ease: "easeInOut" }}
          >
            <img
              src="/assets/Jabanomics.png"
              alt="Jaba The Pepe"
              className="2xl:w-full"
            />
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default JabanomicsSection;
